module.exports = __webpack_public_path__ + "img/mlh_honor_9.53ca6d80.png";